import React from "react";
import { SiteRenderer } from "../site/SiteRenderer";
import { useSiteLayout } from "../site/useSiteLayout";
import { FALLBACK_HOME } from "../site/defaultHome";
import { usePageSeo } from "../lib/usePageSeo";
import { useSeoSettings } from "../lib/useSeoSettings";

export default function Home() {
    const { page, sections, loading, editing, selectedId, onSelect, onEditText } = useSiteLayout("home");
    const brand = useSeoSettings();
    const seo = page?.seo || {};
    usePageSeo(page && !editing ? {
        title: seo.seo_title || page.title || `${brand.brand_name || "ReHealthMe"} — ${brand.tagline || ""}`.trim(),
        description: seo.meta_description || page.description || brand.description || "",
        canonical: seo.canonical_url || window.location.origin,
        image: seo.social_image || brand.social_image || "",
        noindex: !!seo.noindex,
    } : null);

    if (loading) return <div className="bg-bg0 min-h-screen" data-testid="home-loading" />;
    return (
        <div data-testid="home-page">
            <SiteRenderer sections={sections?.length ? sections : FALLBACK_HOME}
                editing={editing} selectedId={selectedId} onSelect={onSelect} onEditText={onEditText} />
        </div>
    );
}
